import { render } from "./product-model-photos.vue?vue&type=template&id=69b40fff&lang=pug"
import script from "./product-model-photos.vue?vue&type=script&lang=js"
export * from "./product-model-photos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__